import { render, staticRenderFns } from "./BannerListComponent.vue?vue&type=template&id=61a59cca&scoped=true&"
import script from "./BannerListComponent.vue?vue&type=script&lang=js&"
export * from "./BannerListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a59cca",
  null
  
)

export default component.exports